export interface MenuItems {
  text?: string;
  class?: string;
}

export const menuItems: MenuItems[] = [
  { text: "Edit", class: "custom-icons icon-pencil" },
  { text: "Delete", class: "custom-icons icon-trash" },
  { text: "View", class: "custom-icons icon-eye" },
];